import React, { useRef, useEffect } from "react";
import clsx from "clsx";
import { useSelector, useDispatch } from "react-redux";
import CanvasDraw from "react-canvas-draw";
import TYPE from "../../../../../../../../constant/TYPE";
import { setQuestionViewAction } from "../../../../../../../../redux/answeringQuestions/questionView";
// import { iOSDotEvent } from "../../../../../../../../utils/canvasDrawUtil";

const Scribble = ( props ) => {

  const canvasDraw = useRef();

  const deviceInfo = useSelector( state => state.deviceInfo );
  const questionView = useSelector(state => state.questionView);
  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const dispatch = useDispatch();
  const setQuestionView = payload => { dispatch( setQuestionViewAction( payload ) ) };

  // useEffect(() => {
  //   if (canvasDraw) {
  //     iOSDotEvent(canvasDraw.current, "learning_picture");
  //   }
  // }, [canvasDraw]);

  useEffect( () => {
    canvasDraw.current && setQuestionView( { scribbleCanvasDraw : canvasDraw.current } );
  }, [ deviceInfo.type ] );

  const CANVAS_DRAW = (
    <CanvasDraw
      ref={canvasDraw}
      canvasWidth="100%"
      canvasHeight="100%"
      backgroundColor="rgba( 0, 0, 0, 0 )"
      hideGrid={true}
      hideInterface={true}
      lazyRadius={0}
      brushRadius={2}
      brushColor="#b1baf2"
      disabled={questionView.isErase}
    />
  )

  return (
    <div className={clsx('learning_picture', answeringQuestions.isShowKeypad && 'unactive')} onTouchStart={answeringQuestions.isShowKeypad ? null : props.onScribble} id="learning_picture">
      { deviceInfo.type && TYPE.DEVICE.PC !== deviceInfo.type && CANVAS_DRAW }
    </div>
  );

};

export default Scribble;
